module.exports = __webpack_public_path__ + "img/meeting-rules-zero-design.c8c70fef.png";